module.exports = {"host":{"api":{"local":"http://192.168.2.51:17510","prod":"https://www.fmelchi.com:17910","test":"https://test.www.fmelchi.com:17910","usProd":"https://us.fmelchi.com:17910","usTest":"https://test.us.fmelchi.com:17910"},"file":{"local":"https://test.file.us.fmelchi.com:17920","prod":"https://file.fmelchi.com:17920","test":"https://test.file.fmelchi.com:17920","usProd":"https://file.us.fmelchi.com:17920","usTest":"https://test.file.us.fmelchi.com:17920"}}}


//////////////////
// WEBPACK FOOTER
// ./src/config/api.hosts.json
// module id = Z2GJ
// module chunks = 25